import api from './api.service';

function unwrap<T>(res: unknown): T {
  const r = res as { data?: unknown };
  const d = r?.data ?? res;
  return (d as { data?: T })?.data ?? (d as T);
}

export interface BankAccountDto {
  id: string;
  company_id: string;
  account_name: string;
  account_number: string;
  bank_name: string;
  branch_name?: string | null;
  currency: string;
  opening_balance: number;
  current_balance: number;
  iban?: string | null;
  swift_code?: string | null;
  gl_account_id?: string | null;
  is_active: boolean;
}

const bankAccountService = {
  async list(): Promise<BankAccountDto[]> {
    const data = unwrap<BankAccountDto[] | undefined>(await api.get('/finance/bank-accounts'));
    return Array.isArray(data) ? data : [];
  },
  async getById(id: string): Promise<BankAccountDto> {
    return unwrap<BankAccountDto>(await api.get(`/finance/bank-accounts/${id}`));
  },
  async create(body: {
    account_name: string;
    account_number: string;
    bank_name: string;
    branch_name?: string;
    currency?: string;
    opening_balance?: number;
    iban?: string;
    swift_code?: string;
    gl_account_id?: string;
    is_active?: boolean;
  }): Promise<BankAccountDto> {
    return unwrap<BankAccountDto>(await api.post('/finance/bank-accounts', body));
  },
  async update(
    id: string,
    body: Partial<{
      account_name: string;
      account_number: string;
      bank_name: string;
      branch_name: string | null;
      currency: string;
      opening_balance: number;
      current_balance: number;
      iban: string | null;
      swift_code: string | null;
      gl_account_id: string | null;
      is_active: boolean;
    }>
  ): Promise<BankAccountDto> {
    return unwrap<BankAccountDto>(await api.put(`/finance/bank-accounts/${id}`, body));
  },
};

export default bankAccountService;
